import { useState } from "react";
import { ArrowsClockwise, SquaresFour } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/api";

export const CarouselCards = ({ job, editable, onUpdateCard, busy }) => {
  const [drafts, setDrafts] = useState({});

  const draft = (idx, field, fallback) =>
    drafts[`${idx}-${field}`] !== undefined ? drafts[`${idx}-${field}`] : fallback;

  const save = (idx, field, value, original) => {
    if (value === original) return;
    onUpdateCard(job, idx, { [field]: value });
  };

  return (
    <div className="mt-3" data-testid={`carousel-cards-${job.id}`}>
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-[#8a90a0]">
        <SquaresFour size={12} weight="fill" /> Carousel — {job.cards.length} cards
      </div>
      <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2.5">
        {job.cards.map((c) => (
          <div key={c.idx} className="rounded-lg border border-[#E5E7EB] overflow-hidden bg-white" data-testid={`carousel-card-${job.id}-${c.idx}`}>
            <img src={`${API}/team/jobs/${job.id}/card-image/${c.idx}?v=${encodeURIComponent(job.updated_at || "")}`}
              alt={c.headline} className="w-full aspect-square object-cover" loading="lazy" />
            <div className="p-1.5 space-y-1">
              {editable ? (
                <>
                  <Input value={draft(c.idx, "headline", c.headline)}
                    onChange={(e) => setDrafts((d) => ({ ...d, [`${c.idx}-headline`]: e.target.value }))}
                    onBlur={(e) => save(c.idx, "headline", e.target.value, c.headline)}
                    maxLength={40} data-testid={`card-headline-input-${job.id}-${c.idx}`}
                    className="h-7 text-[10px] font-bold rounded-md px-1.5" />
                  <Input value={draft(c.idx, "description", c.description)}
                    onChange={(e) => setDrafts((d) => ({ ...d, [`${c.idx}-description`]: e.target.value }))}
                    onBlur={(e) => save(c.idx, "description", e.target.value, c.description)}
                    maxLength={40} placeholder="sub-line" data-testid={`card-desc-input-${job.id}-${c.idx}`}
                    className="h-6 text-[9px] rounded-md px-1.5" />
                  <button onClick={() => onUpdateCard(job, c.idx, { redo_image: true })} disabled={busy}
                    data-testid={`card-redo-btn-${job.id}-${c.idx}`}
                    className="w-full rounded-md border border-[#E5E7EB] text-[9px] font-bold text-[#525866] py-1 hover:bg-[#F3F4F6] disabled:opacity-50">
                    <ArrowsClockwise size={10} className="inline mr-0.5" /> Redo image
                  </button>
                </>
              ) : (
                <>
                  <div className="text-[10px] font-bold text-[#0A0D14] truncate" title={c.headline}>{c.headline}</div>
                  <div className="text-[9px] text-[#8a90a0] truncate">{c.description}</div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
      {editable && <p className="text-[10px] text-[#8a90a0] mt-1.5">Edit any card headline/sub-line (saves when you click away) or redo a single card's image — then approve the set.</p>}
    </div>
  );
};
